import { getInstrumentById } from '@/Wist-blockchain/collections/instruments/instruments.service'
import EquipmentDetail from '@/Wist-blockchain/instruments/view/user/detailInstrument'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { databases } from '@/lib/appwrite'
import { Query } from 'appwrite'

const DB_BLOCKCHAIN = import.meta.env.VITE_BLOCKCHAIN_DATABASE_ID
const DB_MAIN       = import.meta.env.VITE_APPWRITE_DATABASE_ID
const COL_BRANDS    = import.meta.env.VITE_BLOCKCHAIN_BRANDS
const COL_ORGS      = import.meta.env.VITE_ORGANIZATIONS_COLLECTION_ID
const COL_REPORTS   = import.meta.env.VITE_BLOCKCHAIN_SERVICE_REPORT_COLLECTION_ID

export const Route = createFileRoute('/_authenticated/instruments/$id/')({
  beforeLoad: ({ context }) => {
    if (!context.user) throw redirect({ to: '/login' })
    const { isServicioTecnico, isAdmin } = context.userRoles
    if (!isServicioTecnico && !isAdmin) throw redirect({ to: '/unauthorized' })
  },
  loader: async ({ params }) => {
    const instrument = await getInstrumentById(params.id)

    const [brandName, orgName, lastReportRes] = await Promise.all([
      instrument.idBrand
        ? databases.getDocument(DB_BLOCKCHAIN, COL_BRANDS, instrument.idBrand)
            .then(d => d.name as string)
            .catch(() => null)
        : Promise.resolve(null),
      instrument.idOrganization
        ? databases.getDocument(DB_MAIN, COL_ORGS, instrument.idOrganization)
            .then(d => (d.commercialName || d.name) as string)
            .catch(() => null)
        : Promise.resolve(null),
      databases.listDocuments(DB_BLOCKCHAIN, COL_REPORTS, [
        Query.equal('idInstrument', params.id),
        Query.equal('status', 'final'),
        Query.isNotNull('nextQualificationDate'),
        Query.orderDesc('$updatedAt'),
        Query.limit(1),
      ]).catch(() => ({ documents: [] })),
    ])

    const nextMaintenanceDate =
      (lastReportRes.documents[0]?.nextQualificationDate as string | undefined) ?? null

    return { instrument, brandName, orgName, nextMaintenanceDate }
  },
  component: () => {
    const { instrument, brandName, orgName, nextMaintenanceDate } = Route.useLoaderData()
    return (
      <EquipmentDetail
        equipment={instrument}
        brandName={brandName}
        orgName={orgName}
        nextMaintenanceDate={nextMaintenanceDate}
      />
    )
  },
})

